const RELOAD_KEY = 'paranoia-map-reloaded-for'

// CRA build rewrites asset-manifest.json on every deploy with new hashed bundle names.
// If any entrypoint (js/css) listed there isn't loaded on the page, the browser served a stale index.html → reload.
async function checkVersion() {
    try {
        const res       = await fetch('asset-manifest.json', { cache: 'no-store' })
        const manifest  = await res.json()
        const entries   = _.get(manifest, 'entrypoints', [])
        const isCurrent = _.every(entries, (entry: string) => {
            return !!document.querySelector(`script[src$="${entry}"], link[href$="${entry}"]`)
        })

        if (_.isEmpty(entries) || isCurrent) {
            return
        }

        // guard against reload loop if host keeps serving old index.html
        const version = _.join(entries, ',')

        if (sessionStorage.getItem(RELOAD_KEY) === version) {
            return
        }

        sessionStorage.setItem(RELOAD_KEY, version)
        window.location.reload()
    } catch (err) {
        console.error('version-check-failed', err)
    }

    return
}

export default function startVersionCheck() {
    if (process.env.NODE_ENV !== 'production') {
        return
    }

    checkVersion()

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkVersion()
        }

        return
    })

    return
}
